import { render, staticRenderFns } from "./report-tongue.vue?vue&type=template&id=299a2230&scoped=true&"
import script from "./report-tongue.vue?vue&type=script&lang=ts&"
export * from "./report-tongue.vue?vue&type=script&lang=ts&"
import style0 from "./report-tongue.vue?vue&type=style&index=0&id=299a2230&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299a2230",
  null
  
)

export default component.exports